import { Client, Account, Databases, Storage, Functions } from 'appwrite';
import { environment } from '../../../../environments/environment';

const ENDPOINT = environment.apiUrl;
const PROJECT_ID = environment.appwrite.projectId;
export const BucketId = environment.appwrite.imagesBucketId;

// Set up AppWrite client
export const client = new Client();
client.setEndpoint(ENDPOINT).setProject(PROJECT_ID);

// Set up database, account, storage, functions connections
export const databases = new Databases(client);
export const account = new Account(client);
export const storage = new Storage(client);
export const functions = new Functions(client);
